import { render, staticRenderFns } from "./studentworks.vue?vue&type=template&id=6570b0c2&"
import script from "./studentworks.vue?vue&type=script&lang=js&"
export * from "./studentworks.vue?vue&type=script&lang=js&"
import style0 from "./studentworks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports